import axios from 'axios';
import qs from 'qs';

export const getLessons = (params: Record<string, any>) =>
  axios.get(`/api/v1/lessons?${qs.stringify(params)}`);

export const getCatalogLessonById = (lessonId: string) =>
  axios.get(`/api/v1/lessons/${lessonId}`);

export const removeLessonById = (lessonId: string) =>
  axios.delete(`/api/v1/lessons/${lessonId}`);
